<template>
    <div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="float: right">
                <el-button type="primary" @click="saveDataList()">保存</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button @click="currentChangeHandle(1)">更新参数列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%"
        >
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    type="index"
                    header-align="left"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="argName"
                    header-align="left"
                    align="left"
                    width="220"
                    label="参数名称"
            >
            </el-table-column>
            <el-table-column
                    prop="displayName"
                    header-align="left"
                    align="left"
                    label="显示名称"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.displayName"></el-input>
                </template>
            </el-table-column>
<!--            <el-table-column
                    prop="dataType"
                    header-align="left"
                    align="left"
                    label="参数类型"
            >
                <template slot-scope="scope">
                    <el-select
                            v-model="scope.row.dataType"
                            placeholder="参数类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in dataTypeList"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="inputType"
                    header-align="left"
                    align="left"
                    label="输入框类型"
            >
                <template slot-scope="scope">
                    <el-select
                            v-model="scope.row.inputType"
                            placeholder="输入框类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in inputTypeList"
                                :key="item"
                                :label="item"
                                :value="item"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="datasourceType"
                    header-align="left"
                    align="left"
                    label="数据源类型"
            >
                <template slot-scope="scope">
                    <el-select
                            v-model="scope.row.datasourceType"
                            placeholder="数据源类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in datasourceTypeList"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="datasource"
                    header-align="left"
                    align="left"
                    label="数据源"
            >
                <template slot-scope="scope">
                    <el-select
                            v-model="scope.row.datasource"
                            v-if="scope.row.datasourceType==2"
                            placeholder="数据源类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in dictCateList"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <el-input v-else-if="scope.row.datasourceType==3|| scope.row.datasourceType==99"
                              v-model="scope.row.datasource"></el-input>
                    <span v-else>&#45;&#45;</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="required"
                    header-align="left"
                    align="left"
                    label="是否必填"
            >
                <template slot-scope="scope">
                    <el-select v-model="scope.row.required" placeholder="高级查询"
                               style="display: block;margin-bottom: 10px">
                        <el-option
                                v-for="item in trueOrFalseOptions"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="advancedFlag"
                    header-align="left"
                    align="left"
                    label="高级查询"
            >
                <template slot-scope="scope">
                    <el-select v-model="scope.row.advancedFlag" placeholder="高级查询"
                               style="display: block;margin-bottom: 10px">
                        <el-option
                                v-for="item in trueOrFalseOptions"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="sort"
                    header-align="left"
                    align="left"
                    label="排序"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.sort"></el-input>
                </template>
            </el-table-column>-->
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
    </div>
</template>

<script>

    export default {
        props: {
            formId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                dataForm: {
                    searchKey: "",
                    formId: "",
                },
                datasourceTypeList: [],
                inputTypeList: ['text', 'select', 'datetime', 'number'],
                dataTypeList: [],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataListLoading: false,
                dataListSelections: [],
            };
        },
        activated() {

        },
        mounted() {
            this.initSelectData()
            this.dataForm.formId = this.formId;
            this.getDataList();

        },
        methods: {
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                };
                ops = Object.assign(ops, extOps);
                return this.$httpReq(ops);
            },
            initSelectData() {
                let _self = this;
                this.getHttpReq("/customform/getEnumList/0?required=true", "get").then(({data}) => {
                    _self.datasourceTypeList = this.transformToInt(data);
                });
                /*this.getHttpReq("/sys/dict/getDictCategoryList2", "get").then(({data}) => {
                    _self.dictCateList = data;
                });*/
                this.getHttpReq("/customform/getEnumList/1?required=true", "get").then(({data}) => {
                    _self.dataTypeList = this.transformToInt(data);
                });
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$httpReq({
                    url: "/customform/fromdatasetarg/listSingle",
                    method: "post",
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                    data: {
                        filter: {
                            formId: this.dataForm.formId,
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                        searchKey: this.dataForm.searchKey,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
            saveDataList() {
                this.$httpReq({
                    url: "/customform/fromdatasetarg/batchUpdate",
                    method: "post",
                    baseURL: process.env.VUE_APP_proxybaseurl + '',
                    data: this.dataList,
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            }
        },
    };
</script>
